import { ThemeSpaceVariable, ToggleButton } from "@caspeco/casper-ui-library";
// eslint-disable-next-line caspeco-react/discourage-chakra-import
import { ScaleFade } from "@chakra-ui/react";
import { useBookingActionsContext, useBookingStateContext } from "hooks/use-booking-state";
import { saveSectionNameAndWebRuleTitle } from "logger/event-utils";
import { TimeSlot as TimeSlotType } from "types/time-slot";
import { WebRule } from "types/web-rule";

interface TimeSlotProps {
    time: TimeSlotType;
    timeSet: WebRule;
    isSelected?: boolean;
    onTimeClickOverride?: (time: TimeSlotType) => void;
}

export default function TimeSlot({
    time,
    timeSet,
    isSelected,
    onTimeClickOverride,
}: TimeSlotProps) {
    const state = useBookingStateContext();
    const { handleCreateBooking } = useBookingActionsContext();

    const handleClick = () => {
        if (onTimeClickOverride) {
            onTimeClickOverride(time);
        } else {
            const newTime = { ruleId: time.ruleId, start: time.start, end: time.end };
            saveSectionNameAndWebRuleTitle(time.name, time.title);
            const stateWithTimes = {
                ...state,
                times: [newTime],
                isWaitList: false,
            };
            const isRuleWithMenu = Boolean(timeSet.menuGuid);
            const isRuleWithPayment = timeSet.hasAnyPaymentRule();
            handleCreateBooking?.(stateWithTimes, isRuleWithMenu, isRuleWithPayment);
        }
    };

    return (
        <ScaleFade initialScale={0.9} in={true} transition={{ enter: { duration: 0.5 } }}>
            <ToggleButton
                key={time.start.format("HH:mm")}
                className="timeButton"
                onClick={handleClick}
                w="full"
                px={ThemeSpaceVariable.Small}
                size="lg"
                isPressed={isSelected}
            >
                {time.start.format("HH:mm")}
            </ToggleButton>
        </ScaleFade>
    );
}
